// PopupNotificationList.jsx
import React from 'react';
import PropTypes from 'prop-types';
import PopupNotificationHandler from '../container/PopupNotificationHandler.js';

export class PopupNotificationList extends React.PureComponent {
  renderPopupNotification = notificationTag => {
    const { isNotificationCenter } = this.props;
    return (
      <PopupNotificationHandler
        key={notificationTag}
        notificationTag={notificationTag}
        isNotificationCenter={isNotificationCenter}
      />
    );
  };

  render() {
    const { notificationTags } = this.props;
    if (notificationTags.length === 0) return null;
    return notificationTags.map(this.renderPopupNotification);
  }
}

PopupNotificationList.propTypes = {
  isNotificationCenter: PropTypes.bool,
  notificationTags: PropTypes.array,
};

PopupNotificationList.defaultProps = {
  isNotificationCenter: false,
  notificationTags: [],
};

export default PopupNotificationList;
